import React, { Component } from 'react';

import { getClass } from 'utils/component-helpers';

import './basic-dropdown.scss';

// This dropdown should just have a selectable list of items, nothing more
class BasicDropdown extends Component {
	constructor(props) {
		super(props);

		this.dropdownDiv = React.createRef();

		this.state = {
			opened: false,
			selectedItem: props.initialSelection || props.initialSelection === 0 ?
				props.initialSelection : null,
		};

		this.handleClickOutside = this.handleClickOutside.bind(this);
	}

	componentDidMount() {
		window.addEventListener('click', this.handleClickOutside);
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.handleClickOutside);
	}

	componentDidUpdate(prevProps) {
		if (this.props.initialSelection !== prevProps.initialSelection) {
			this.setState({selectedItem: this.props.initialSelection});
		}
	}

	toggleDropdown() {
		this.setState({
			opened: !this.state.opened,
		}, () => {
			if (this.props.handleDropdown) this.props.handleDropdown(this.state.opened);
		});
	}

	handleClickOutside(e) {
		e.stopPropagation();
		/*
		 * For auction overrides, use parent container so that clicking
		 * input field does not close dropdown.
		 */
		const div = this.props.parentContain
			? this.dropdownDiv.current.parentElement
			: this.dropdownDiv.current;

		if (!this.state.opened || div.contains(e.target)) return;

		this.toggleDropdown(e);
	}

	selectItem(idx, e) {
		e.stopPropagation();
		this.props.selectItem(idx);
		this.setState({selectedItem: idx});
		this.toggleDropdown();
	}

	render() {
		const {dropdownLabel, items} = this.props;

		const labelClass = dropdownLabel ? dropdownLabel.replace(/\s+/g, '-').toLowerCase() : '';

		const selected = this.state.selectedItem;

		const dropdownList = items.map((fields, idx) => {

			return (
				<div key={fields.label}
					className={getClass('dropdown-item', {'selected': selected === idx})}>
					<div
						className="item-name"
						onClick={(e) => this.selectItem(idx, e)}>
						{fields.label}
					</div>
				</div>
			);
		});

		const dropdownMenu = this.state.opened ? (
			<div className="dropdown-menu">
				{dropdownList}
			</div>
		) : null;

		return (
			<div
				ref={this.dropdownDiv}
				className={`basic-dropdown${this.state.opened ? ' open' : ''}`}
				onClick={this.toggleDropdown.bind(this)}>
				<div className={`dropdown-label ${labelClass}`}>
					<span>
						{this.props.dropdownLabel}
					</span>
				</div>
				<span className={this.state.opened ? 'arrow-up' : 'arrow-down'} />
				{dropdownMenu}
			</div>
		);
	}
}

export default BasicDropdown;
